import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import Card from './ui/Card';
import { ui } from './ui/tokens';
import DownloadIcon from '../assets/download.png';
import UploadIcon from '../assets/upload.png';
import EyeIcon from '../assets/eye.png';

export type SaveImageCardProps = {
	open: boolean;
	onClose: () => void;
	onLocalDevice: () => void;
	onOnline: () => void;
	onPreview: () => void;
	onlineSaving: boolean;
};

/** "Save image" tool (style guide R16): save to the device, save online and close, or preview. */
function SaveImageCard({ open, onClose, onLocalDevice, onOnline, onPreview, onlineSaving }: SaveImageCardProps) {
	return (
		<Card open={open} title="Save image" onClose={onlineSaving ? undefined : onClose}>
			<Options>
				<Option type="button" onClick={onLocalDevice} disabled={onlineSaving}>
					<img src={DownloadIcon} alt="" width={33} height={33} />
					<span>Local device</span>
				</Option>
				<Option type="button" onClick={onOnline} disabled={onlineSaving}>
					{onlineSaving ? <CircularProgress size={30} sx={{ color: ui.gold }} /> : <img src={UploadIcon} alt="" width={33} height={33} />}
					<span>Online</span>
				</Option>
				<Option type="button" onClick={onPreview} disabled={onlineSaving}>
					<img src={EyeIcon} alt="" width={33} height={33} />
					<span>Preview</span>
				</Option>
			</Options>
			<Hint>Online saves your artwork to My Pixels and closes the editor.</Hint>
		</Card>
	);
}

export default SaveImageCard;

const Options = styled.div`
	display: flex;
	justify-content: space-around;
	margin-top: 22px;
`;

const Option = styled.button`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	min-width: 80px;
	min-height: 64px;
	background: none;
	border: none;
	cursor: pointer;

	span {
		font-family: ${ui.font};
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		color: ${ui.label};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

const Hint = styled.p`
	margin: 18px 0 0;
	text-align: center;
	font-family: ${ui.font};
	font-size: 12px;
	color: ${ui.label};
`;
